import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Actions from "../../../store/actions"
import { useSelector, useDispatch } from "react-redux"
import Alert from "../../common/alert";
import Swal from 'sweetalert2'
import { detect } from 'detect-browser';
import { CustomLogger } from "../../../store/actions"
import { history } from "../../../index"
import swal from "../../common/alert"
const browser = detect();
const MeetingControlBar = props => {

    const dispatch = useDispatch();

    const [IsVideoOn, setIsVideoOn] = useState(true)
    const [NumberOfCams, setNumberOfCams] = useState(1)
    const [CurrentCam, setCurrentCam] = useState(1)
    const [IsMicOn, setIsMicOn] = useState(true)
    const [CanStopShare, setCanStopShare] = useState(false)
    const [NumberOfNewMsg, setNumberOfNewMsg] = useState(0)
    const [ShouldShowDot, setShouldShowDot] = useState(false)
    const [IsToolsOpen, setIsToolsOpen] = useState(false)
    const [People, setPeople] = useState({})
    const [useLess, setuseLess] = useState(1)

    const isHost = useSelector(({ meeting }) => meeting.IsHost)

    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)
    const ScreenShareOn = useSelector(({ meeting }) => meeting.ScreenShareOn);
    const UserData = useSelector(({ auth }) => auth.UserData);
    const isAuth = useSelector(({ auth }) => auth.isAuth);
    const localMuteOrNot = useSelector(({ meeting }) => meeting.localMuteOrNot)
    const SOAP = useSelector(({ meeting }) => meeting.SOAP)
    const Chat = useSelector(({ meeting }) => meeting.Chat)
    const ImagesToMap = useSelector(({ meeting }) => meeting.ScreenShotImages)
    const People2 = useSelector(({ meeting }) => meeting.People)

    const IsMobTab = window.innerWidth < 1024 ? true : false; // true means tab and mob && false means desktop




    useEffect(() => {
        if (People2) setPeople(People2)
        UseLessFunction()

    }, [People2])

    useEffect(() => {
        setUpCam()
    }, [meetingSession])

    useEffect(() => {
        if (!props.ChatBoxOpen && Chat.length > 0) {
            setNumberOfNewMsg(NumberOfNewMsg + 1)
            setShouldShowDot(true)
        }
    }, [Chat])
    useEffect(() => {
        if (props.ChatBoxOpen) {
            setShouldShowDot(false)
            setNumberOfNewMsg(0)
        }
    }, [props.ChatBoxOpen])


    useEffect(() => {

        props.setAmISharingScreen(CanStopShare)
    }, [CanStopShare])

    useEffect(() => {
        if (!ScreenShareOn) {
            setCanStopShare(false)
        }
        if (ScreenShareOn) {
            props.CloseChatBoxHARD()

        }

    }, [ScreenShareOn])

    function UseLessFunction() {
        setuseLess(useLess + 1)

        setTimeout(() => {
            UseLessFunction()
        }, 2000);
    }

    async function setUpCam() {
        if (meetingSession) {
            const videoInputDevices = await meetingSession.audioVideo.listVideoInputDevices();
            setNumberOfCams(videoInputDevices.length)
        }
    }

    async function camSwitcher() {
        if(!IsVideoOn) return
        try {
            if (CurrentCam === 1) {
                meetingSession.audioVideo.stopLocalVideoTile();
                await meetingSession.audioVideo.stopVideoInput();
                const videoInputDevices = await meetingSession.audioVideo.listVideoInputDevices();
                const videoInputDeviceInfo = videoInputDevices[videoInputDevices.length - 1]
                await meetingSession.audioVideo.startVideoInput(videoInputDeviceInfo?.deviceId);
                meetingSession.audioVideo.startLocalVideoTile();
                setCurrentCam(2)
            }
            if (CurrentCam === 2) {
                meetingSession.audioVideo.stopLocalVideoTile();
                await meetingSession.audioVideo.stopVideoInput();
                const videoInputDevices = await meetingSession.audioVideo.listVideoInputDevices();
                const videoInputDeviceInfo = videoInputDevices[0]
                await meetingSession.audioVideo.startVideoInput(videoInputDeviceInfo?.deviceId);
                meetingSession.audioVideo.startLocalVideoTile();
                setCurrentCam(1)
            }
        } catch (error) {
            alert(error)
            console.log(error)
        }
    }

    return (
        <span style={IsMobTab ? { height: props.ControlBarOpen ? "88px" : "0px" } : {}} className={`ControlsBar `}>

            <div style={IsMobTab ? { height: props.ControlBarOpen ? "88px" : "0px" } : {}} className="ControlsBarTools">
                <div style={IsMobTab ? { height: props.ControlBarOpen ? "88px" : "0px" } : {}} className="ButtonToolBox"   >
                    <span
                     onClick={async () => {
                        if (Object.keys(People)?.length < 1) return
                        let ShouldQuitAll = false;

                        if (isHost) {

                            // ShouldQuitAll = await Swal("End meeting for everyone", "Are you sure you want to end meeting for everyone?", {
                            //     buttons: ["No, Just leave meeting", "Yes, End for everyone!"],
                            //     closeOnClickOutside: false,
                            //     closeOnEsc: false
                            // })

                            const res = await Swal.fire({
                                title: "Are you sure you want to end meeting for everyone?",
                                text: ImagesToMap.length > 0 ? "The captured screens will be sent to your registered email when the meeting ends. The links are valid for 6 hours, please download all the files before expiration." : "",
                                showCloseButton: true,
                                showCancelButton: true,
                                confirmButtonText: "Yes, End for everyone!",
                                cancelButtonText: "No, Just leave meeting"
                            })

                            if (!res.value && res.dismiss !== "cancel") return

                            ShouldQuitAll = res.value || false
                        }
                        if (isHost) {

                            const CALL_END_SIGNAL = "CALL_END_SIGNAL"

                            meetingSession?.audioVideo.realtimeSendDataMessage(CALL_END_SIGNAL, JSON.stringify({
                                hasHostLeft: true,
                                hasCallEnded: ShouldQuitAll,
                            }), 100000)

                        }
                        if (!isHost) {
                            const query = new URLSearchParams(location.search)

                            const IsRegisteredPatients = !query.get("userType") && query.get("userType") != "Patient"
                            const LeaveOrNot = await Swal.fire({
                                title: "Are you sure you want to leave?",
                                text: !IsRegisteredPatients ? "If there are any captured screens or attachments, they will be sent to you on your registered email. The links are valid for 6 hours, please download all the files before expiration." : "",
                                showCloseButton: true,
                                showCancelButton: true,
                                confirmButtonText: "Yes, Leave meeting!",
                                cancelButtonText:  "      Cancel       "
                            })
                            if (!LeaveOrNot.value) return



                        }


                        meetingSession.audioVideo.removeLocalVideoTile();
                        // window.removeEventListener('beforeunload', function (e) {
                        //     // Cancel the event
                        //     // e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
                        //     // Chrome requires returnValue to be set
                        //     // e.returnValue = '';
                        // });
                        dispatch(Actions.LeaveMeeting(window.location.pathname.replace("/room/", "").substring(0, 9), ShouldQuitAll,))

                        // const query2 = new URLSearchParams(location.search)

                        // if (query2.has("videosessionid")){
                        //     if (isHost) {
                        //         history.push("/room")
                        //     }
                        //     history.go()
                        // }
                        props.openEndMeetingDialog()

                    }} className="ButtonToolBoxInside" style={{ background: "url(/images/icons/record-solid.svg)", cursor: Object.keys(People)?.length < 1 ? "not-allowed" : "pointer" }}   >
                        <img
                            src="/images/icons/hang-up.png"
                        />
                    </span>
                    <h3 className="someTextHeading">
                        Leave Call
                        </h3>
                </div>
                <div className="ButtonToolBox"   >
                    <span
                        onClick={async () => {
                            if (Object.keys(People)?.length < 1) return

                            if (IsVideoOn) {
                                setIsVideoOn(false)
                                meetingSession.audioVideo.stopLocalVideoTile();
                                await meetingSession.audioVideo.stopVideoInput();
                            } else {
                                setIsVideoOn(true)
                                const videoInputDevices = await meetingSession.audioVideo.listVideoInputDevices();
                                const videoInputDeviceInfo = videoInputDevices[0]
                                await meetingSession.audioVideo.startVideoInput(videoInputDeviceInfo.deviceId);
                                meetingSession.audioVideo.startLocalVideoTile();
                            }
                        }}
                        className={`ButtonToolBoxInside ${IsVideoOn ? " activeButton" : ""}`}
                        style={{ cursor: Object.keys(People)?.length < 1 ? "not-allowed" : "pointer" }}
                    >
                        <img
                            src={IsVideoOn ? "/images/icons/video-icon.svg" : "/images/icons/video-icon-off.svg"}
                        />
                    </span>
                    <h3 className="someTextHeading">
                        Your Video
                        </h3>
                </div>
                <div className="ButtonToolBox"   >
                    <span onClick={() => {
                        if (Object.keys(People)?.length < 1) return

                        // swal("You can not unmute yourself right now!", "The host has muted all the participants", "warning")

                        // if(!IsMicOn && !localMuteOrNot){

                        // }
                        setIsMicOn(meetingSession?.audioVideo?.realtimeIsLocalAudioMuted())
                        dispatch(Actions.MuteUnmute(meetingSession?.audioVideo?.realtimeIsLocalAudioMuted()))
                    }}
                        className={`ButtonToolBoxInside ${localMuteOrNot ? " activeButton" : ""}`}
                        style={{ cursor: Object.keys(People)?.length < 1 ? "not-allowed" : "pointer" }}
                    >
                        <img
                            src={localMuteOrNot ? "/images/icons/mic-icon.svg" : "/images/icons/mic-muted.svg"}
                        />
                    </span>
                    <h3 className="someTextHeading">
                        Your Mic
                        </h3>
                </div>
                <div className="ButtonToolBox"   >
                    <span className="ButtonToolBoxInside" onClick={async () => {
                        if (isAuth) {
                            await navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}`)
                            Alert(`${window.location.origin}${window.location.pathname}`, 'success', 'Link copied to clipboard.')
                        } else {
                            await navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}`)
                            Alert(`${window.location.origin}${window.location.pathname}`, 'success', 'Link copied to clipboard.')
                        }

                    }} >
                        <img
                            src="/images/icons/add.svg"
                        />
                    </span>
                    <h3 className="someTextHeading">
                        Invite
                        </h3>
                </div>
                <div className="ButtonToolBox"   >
                    <span
                        onClick={async () => {
                            try {
                                if (Object.keys(People)?.length < 1) return


                                if (browser.name == "safari") {
                                    if (parseInt(browser.version) < 13) {
                                        return swal("Warning!", `Your safari version ${browser.version} does not support share screen feature, Please upgrade to version 13+ `, "warning")
                                    }
                                }
                                const SCREEN_SHARE = "SCREEN_SHARE"


                                if (!ScreenShareOn) {
                                    setTimeout(async () => {
                                        try {
                                            CustomLogger("screen share starting...")
                                            const res = await meetingSession.audioVideo.startContentShareFromScreenCapture();
                                            CustomLogger("screen share DONE...")

                                            meetingSession?.audioVideo.realtimeSendDataMessage(SCREEN_SHARE, JSON.stringify({
                                                Start: true,
                                                PersonWhoIsSharingScreen: meetingSession._configuration.credentials.attendeeId,
                                            }), 100000)
                                            dispatch({
                                                type: Actions.PERSON_WHO_IS_SHARING_SCREEN,
                                                payload: meetingSession._configuration.credentials.attendeeId
                                            })
                                            dispatch({
                                                type: Actions.SCREEN_SHARE_ON,
                                                payload: true,
                                            })
                                            setCanStopShare(true)
                                        } catch (error) {
                                            CustomLogger("screen share Error...")
                                            console.table(error)

                                            if (error.message === "Permission denied by system") {
                                                // return swal("Can't share screen as you don't have permission! ", `Go to: System Preference —> Choose Security & Privacy —> Choose Screen Recording —> inside “Privacy” tab, please make sure to check your browser to allow screen share! `, "error")
                                                Swal.fire({
                                                    imageUrl: "/images/request2.png",
                                                    // imageHeight: 300,
                                                    imageWidth: 335,
                                                    imageAlt: 'A tall image',
                                                    showCloseButton: true,
                                                    title: "Can't share screen as you don't have permission! ",
                                                    text: "Please go to System Preference, then choose Security & Privacy, choose Screen Recording. Inside the “Privacy” tab, please make sure to check your browser to allow the screen share feature. It will close your current browser."
                                                })
                                            }

                                            meetingSession?.audioVideo.realtimeSendDataMessage(SCREEN_SHARE, JSON.stringify({
                                                Start: false,
                                                PersonWhoIsSharingScreen: "",
                                            }), 100000)
                                            dispatch({
                                                type: Actions.PERSON_WHO_IS_SHARING_SCREEN,
                                                payload: ""
                                            })
                                        }
                                    }, 500);





                                }
                                if (CanStopShare) {
                                    CustomLogger("Stopping screen share")
                                    await meetingSession.audioVideo.stopContentShare();
                                    meetingSession?.audioVideo.realtimeSendDataMessage(SCREEN_SHARE, JSON.stringify({
                                        Start: false,
                                        PersonWhoIsSharingScreen: "",

                                    }), 100000)
                                    dispatch({
                                        type: Actions.PERSON_WHO_IS_SHARING_SCREEN,
                                        payload: ""
                                    })
                                    dispatch({
                                        type: Actions.SCREEN_SHARE_ON,
                                        payload: false,
                                    })
                                    setCanStopShare(false)
                                }
                            } catch (error) {
                                console.log(error)
                            }
                        }}

                        // AmISharingScreen
                        className={`ButtonToolBoxInside ${props.AmISharingScreen ? " activeButton" : ""}`}
                        style={{ cursor: Object.keys(People)?.length < 1 ? "not-allowed" : "pointer" }}
                    >
                        <img
                            src="/images/icons/screenshare.svg"
                        />
                    </span>
                    <h3 className="someTextHeading">
                        Share Screen
                        </h3>
                </div>
                {
                    NumberOfCams > 1 ? (
                        <div className="ButtonToolBox"   >
                            <span className="ButtonToolBoxInside" onClick={async () => {
                                camSwitcher()
                            }} >
                                <img
                                    style={{ height: "30px" }}
                                    src="/images/cameraFlip.svg"
                                />
                            </span>
                            <h3 className="someTextHeading">
                                Switch Cam
                                </h3>
                        </div>
                    ) : null
                }

                {/* ChatBoxOpen */}
                <div className="ButtonToolBox" style={{ position: "relative" }} >

                    {
                        ShouldShowDot ? (
                            <div
                                className="THEDOT"
                            // style={{ position: "absolute", border: "4px solid red", borderRadius: "100%", top: "10px", left: "20px" }}

                            >
                                {NumberOfNewMsg}
                            </div>
                        ) : null
                    }
                    <span onClick={() => {
                        setIsToolsOpen(!IsToolsOpen)
                        props.CloseChatBox()
                    }} className={`ButtonToolBoxInside ${props.ChatBoxOpen ? " activeButton" : ""}`}   >
                        <img
                            style={{ height: "20px" }}
                            src="/images/icons/new_msg_icon.png"
                        />
                    </span>
                    <h3 className="someTextHeading">
                        Tools ({NumberOfNewMsg})
                        </h3>
                </div>
            </div>
        </span>

    )
}
MeetingControlBar.propTypes = {
    openEndMeetingDialog: PropTypes.func.isRequired,
    CloseChatBox: PropTypes.func.isRequired,
}

export default MeetingControlBar
